<div class="search" appClickOutside (clickOutside)="searchService.isSearchDropdownOpened.set(false)">
    @if (searchService.mobileSearchOpen() || (!sidebarService.isBelowMobileWidth() && !searchService.mobileSearchOpen())) {
        <div class="search-hook" [class.search-input-mobile]="sidebarService.isBelowMobileWidth()">
            <div class="input-group-text icon-text-wrapper search-wrapper" id="search-input-wrapper">
                @if (searchService.loadingFuzzy()) {
                    <span class="search-icon">
                        <app-loading-indicator size="mini" color="secondary" />
                    </span>
                } @else {
                    <span class="search-icon">
                        <img src="assets/icons/search-icon.svg" alt="search" />
                    </span>
                }
                <input
                    #searchInput
                    id="search-input-id"
                    class="search-input"
                    name="q"
                    [type]="sidebarService.isBelowMobileWidth() ? 'search' : 'text'"
                    placeholder="{{ 'misc.search_placeholder' | translate }}"
                    autocomplete="off"
                    [value]="searchService.searchInputValue()"
                    (focus)="toggleSearchDropdown()"
                    (input)="onSearchInputChange($event)"
                />
                @if (!sidebarService.isBelowMobileWidth()) {
                    <kbd class="key-box">
                        {{ isMac ? "⌘ K" : "Ctrl + K" }}
                    </kbd>
                }
            </div>
            @if (searchService.isSearchDropdownOpened()) {
                <div class="prevent-select">
                    <app-search-preview (itemClickedEvent)="handleItemClick($event)" (searchSuggestionSelected)="handleSuggestion($event)"></app-search-preview>
                </div>
            }
        </div>
    }
    @if (searchService.mobileSearchOpen() && sidebarService.isBelowMobileWidth()) {
        <div (click)="toggleMobileSearchOpen()" class="close-icon"></div>
    }

    @if (sidebarService.isBelowMobileWidth() && !searchService.mobileSearchOpen()) {
        <div class="search-mobile-wrapper">
            <span (click)="toggleMobileSearchOpen()" class="search-icon-mobile"></span>
        </div>
    }
</div>
